import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_J_LIMIT_MANAGER = '/spe-j-limit-manager';
let SpeJLimitManager = class SpeJLimitManager {
    constructor(api) {
        this.api = api;
    }
    getMyLimitsType(groupType) {
        const url = `${SPE_J_LIMIT_MANAGER}/v1/my-limits/types?groupType=${groupType}`;
        return this.api.get(url);
    }
    getTransactionOptions() {
        const url = `${SPE_J_LIMIT_MANAGER}/v1/transaction-type`;
        return this.api.get(url);
    }
    getMyLimitsByType(type, uuidWL, uuidAP, period) {
        const url = `${SPE_J_LIMIT_MANAGER}/v1/my-limits/by-types?type=${type}&uuidWhiteLabel=${uuidWL}&uuidAccountPayment=${uuidAP}&period=${period}`;
        return this.api.get(url);
    }
    requestLimitsAdjustment(transactionTypeId, typeId, uuidWL, uuidAP, valuePerPeriod, valuePerTransaction) {
        const url = `${SPE_J_LIMIT_MANAGER}/v1/my-limits`;
        return this.api.post(url, { transactionTypeId: transactionTypeId, typeId: typeId, uuidWhiteLabel: uuidWL, uuidAccountPayment: uuidAP, valuePerPeriod: valuePerPeriod, valuePerTransaction: valuePerTransaction });
    }
    requestMoreLimit(transactionTypeId, typeId, uuidWL, uuidAP, maximumValuePerPeriod, maximumValuePerTransaction) {
        const url = `${SPE_J_LIMIT_MANAGER}/v1/my-limits/max-request`;
        return this.api.post(url, { transactionTypeId: transactionTypeId, typeId: typeId, uuidWhiteLabel: uuidWL, uuidAccountPayment: uuidAP, maximumValuePerPeriod: maximumValuePerPeriod, maximumValuePerTransaction: maximumValuePerTransaction });
    }
    getLimitsHistory(uuidWL, uuidAP, page, startDate, endDate, groupType, type, status, period, fieldOrder, directionSort, limit) {
        const url = `${SPE_J_LIMIT_MANAGER}/v1/my-limits/history?uuidWhiteLabel=${uuidWL}&uuidAccountPayment=${uuidAP}&page=${page}&startDate=${startDate}&endDate=${endDate}&groupType=${groupType}&type=${type}&status=${status}&period=${period}&fieldOrder=${fieldOrder}&directionSort=${directionSort}&limit=${limit}`;
        return this.api.get(url);
    }
};
SpeJLimitManager.ctorParameters = () => [
    { type: ApiService }
];
SpeJLimitManager = __decorate([
    Injectable()
], SpeJLimitManager);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

let UiPxTransferLimitModule = class UiPxTransferLimitModule {
};
UiPxTransferLimitModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService, SpeJLimitManager,
        ]
    })
], UiPxTransferLimitModule);

/*
 * Public API Surface of ui-px-token
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeJLimitManager, UiPxTransferLimitModule };
//# sourceMappingURL=wlp-ui-px-transfer-limit.js.map
